import { useParams, Navigate } from "react-router-dom";
import { AppConfigWizard } from "@/components/applications/config/AppConfigWizard";
import { useAllAppConfigs } from "@/hooks/useAppConfigurations";
import { useApplications } from "@/hooks/useApplications";

export default function EditAppConfigPage() {
  const { id } = useParams();
  const { data: configs = [], isLoading } = useAllAppConfigs();
  const { applications } = useApplications();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  const config = configs.find((c) => c.policyId === id);
  if (!config) {
    return <Navigate to="/configurations/app-config" replace />;
  }

  const catalogApp = applications.find((a) => a.bundleId === config.bundleId);

  return (
    <AppConfigWizard
      initial={{
        existingPolicyId: config.policyId,
        target: {
          mode: catalogApp ? "catalog" : "external",
          catalogAppId: catalogApp?.id,
          appName: catalogApp?.name ?? config.bundleId,
          bundleId: config.bundleId,
        },
        configName: config.configName,
        keys: config.keys,
      }}
    />
  );
}
